// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1ZYAm","productName":"Table_productName__3kEQV"};